import emptySliceApi from '../../shared/store/emptyApiSlice';
import { ProductApiModel } from '../../shared/models/ProductModel';
import { AgreementApiModel, DealStatus } from '../../shared/models/DealModel';
import { DealProducts } from '../../shared/models/ProductGroupModel';

export interface AccountSummary {
  id: string;
  dealName: string;
  products: ProductApiModel[];
  productsQuantity: number;
  totalSpend: number;
  totalSavings: number;
  totalEnrollments: number;
  zones: [];
  expirationDate: string;
  enabled: boolean;
  hidden: boolean;
  reseller: boolean;
}

export interface AccountSummaryTotals {
  totalSpent: number;
  totalSavings: number;
  numberOfAgreements: number;
  totalRegisteredUsers: number;
  totalEnrollments: number;
}

export interface DashboardDealsRequestParams {
  accountId: string;
  status: number;
  currentPage: number;
  pageSize: number;
}

export interface DashboardDealsQueryResult {
  currentPage: number;
  pageSize: number;
  pageCount: number;
  totalItemCount: number;
  items: AgreementApiModel[];
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardDeals: builder.query<
      DashboardDealsQueryResult,
      DashboardDealsRequestParams
    >({
      query: ({
        accountId,
        currentPage = 1,
        pageSize = 10,
        status = DealStatus.All,
      }: DashboardDealsRequestParams) =>
        `v4/accounts/${accountId}/deals/paged?Page=${currentPage}&PageSize=${pageSize}&DealStatus=${status}`,
      providesTags: ['Deal'],
    }),
    getDashboardAccountSummaryTotals: builder.query<
      AccountSummaryTotals,
      { accountId: string }
    >({
      query: ({ accountId }) => `v4/accounts/${accountId}/summary/detailed`,
      providesTags: ['Deal'],
    }),
    getDealProducts: builder.query<
      DealProducts,
      { accountId: string; dealId: string }
    >({
      query: ({ accountId, dealId }) =>
        `v4/accounts/${accountId}/deals/${dealId}/products`,
      providesTags: (_result, _error, { dealId }) => [
        { type: 'Deal', id: dealId },
      ],
    }),
  }),
});

export const {
  useGetDashboardDealsQuery,
  useGetDashboardAccountSummaryTotalsQuery,
  useGetDealProductsQuery,
} = apiSlice;
